import React from "react";
import { defineMessages } from "react-intl";
import ProductReview from "theme/components/organisms/ProductReview";
import Wysiwyg from "theme/modules/Wysiwyg";
import Details from "theme/modules/ProductView/Details";
import ErrorBoundary from "theme/components/helpers/ErrorBoundary";
import TabView from "theme/components/organisms/TabView";

const messages = defineMessages({
  description: {
    id: "modules.ProductView.Synthesis.description",
    defaultMessage: "Description",
  },
  composition: {
    id: "modules.ProductView.Synthesis.composition",
    defaultMessage: "Composition",
  },
  compositionPercentage: {
    id: "modules.ProductView.Synthesis.compositionPercentage",
    defaultMessage: "Composition:",
  },
  maintenanceTip: {
    id: "modules.ProductView.Synthesis.maintenanceTip",
    defaultMessage: "Maintenance",
  },
  sizeGuide: {
    id: "modules.ProductView.Synthesis.sizeGuide",
    defaultMessage: "Size guide ",
  },
  review: {
    id: "modules.ProductView.Synthesis.review",
    defaultMessage: "Review",
  },
});

const TabContent = ({ wysiwyg, text, prefix, compositionPercentage }) => {
  if (wysiwyg || prefix) {
    return (
      <>
        {prefix && (
          <div className="product__tab-content__text">
            {compositionPercentage && <strong>{compositionPercentage} </strong>}
            {prefix}
          </div>
        )}
        {wysiwyg && <Wysiwyg content={wysiwyg.content} />}
      </>
    );
  }

  return (
    <div className="product__tab-content">
      <div className="product__tab-content__text">
        {prefix && <div>{prefix}</div>}
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  );
};

const getProductsTabs = (
  intl,
  description,
  descriptionMedia,
  composition,
  composition_percentage,
  maintenanceTip,
  sizeGuideCms,
  reviews
) => {
  return [
    {
      title: intl.formatMessage(messages.description),
      renderContent: () => (
        <TabContent
          text={description}
          image={descriptionMedia && descriptionMedia.url}
          alt={descriptionMedia && descriptionMedia.alt}
        />
      ),
      shouldIgnore: false,
    },
    {
      title: intl.formatMessage(messages.composition),
      renderContent: () => (
        <TabContent
          wysiwyg={composition}
          prefix={composition_percentage}
          compositionPercentage={intl.formatMessage(
            messages.compositionPercentage
          )}
          alt={intl.formatMessage(messages.composition)}
        />
      ),
      shouldIgnore: !composition && !composition_percentage,
    },
    {
      title: intl.formatMessage(messages.maintenanceTip),
      renderContent: () => (
        <TabContent
          wysiwyg={maintenanceTip}
          alt={intl.formatMessage(messages.maintenanceTip)}
        />
      ),
      shouldIgnore: !maintenanceTip,
    },
    {
      title: intl.formatMessage(messages.sizeGuide),
      renderContent: () => (
        <TabContent
          wysiwyg={sizeGuideCms}
          alt={intl.formatMessage(messages.sizeGuide)}
        />
      ),
      shouldIgnore: !sizeGuideCms,
    },
    {
      title: intl.formatMessage(messages.review),
      renderContent: () => <ProductReview reviews={reviews} />,
      id: "tab-review",
      shouldIgnore: !reviews?.length > 0,
    },
  ].filter(({ shouldIgnore }) => !shouldIgnore);
};

const AdditionalInformations = ({
  intl,
  description,
  descriptionMedia,
  composition,
  composition_percentage,
  maintenanceTip,
  additionalInformation,
  sizeGuideCms,
  reviews,
}) => {
  const productTabs = getProductsTabs(
    intl,
    description,
    descriptionMedia,
    composition,
    composition_percentage,
    maintenanceTip,
    sizeGuideCms,
    reviews
  );

  return (
    <div className="product__additional-informations">
      <div className="product__additional-informations__tab-view">
        <ErrorBoundary>
          {({ hasError }) => (hasError ? null : <TabView tabs={productTabs} />)}
        </ErrorBoundary>
      </div>
      <ErrorBoundary>
        {({ hasError }) =>
          hasError ||
          !(
            additionalInformation && additionalInformation.length > 0
          ) ? null : (
            <Details additionalInformation={additionalInformation} />
          )
        }
      </ErrorBoundary>
    </div>
  );
};

export default AdditionalInformations;
